export const ABOUT_MAX = 1200;

export const FIELD_ERRORS = {
  website: "Enter a full website address, like yourbrokerage.com.",
  phone: "Enter a phone number with 7 to 15 digits.",
  iabsUrl: "Enter the full https link to your completed IABS form.",
  logoUrl: "Upload the logo again.",
  coverUrl: "Upload the cover image again.",
};

export const aboutErrorOf = (code, term) => {
  const phrase = term ? `\u201c${term}\u201d` : "that phrase";
  switch (code) {
    case "hasEmail":
      return "Take the email address out of About. People reach your office through Website and Office phone under\u00a0Contact.";
    case "hasLink":
      return "Take the web address out of About and add it as Website under\u00a0Contact.";
    case "hasPhone":
      return "Take the phone number out of About and add it as Office phone under\u00a0Contact.";
    case "bannedPhrase":
      return `Reword ${phrase} so your changes can save. Gitcha pages do not use that\u00a0phrase.`;
    case "fairHousing":
      return `Reword ${phrase} so your changes can save. It could read as a preference under fair housing\u00a0law.`;
    case "tooLong":
      return `Keep the description under ${ABOUT_MAX}\u00a0characters.`;
    default:
      return code ? "Check the description and try\u00a0again." : "";
  }
};

export const draftOf = (settings) => ({
  logoUrl: settings?.logoUrl || "",
  coverUrl: settings?.coverUrl || "",
  about: settings?.about || "",
  website: settings?.website || "",
  phone: settings?.phone || "",
  iabsUrl: settings?.iabsUrl || "",
});

export const isDirty = (draft, settings) =>
  JSON.stringify(draft) !== JSON.stringify(draftOf(settings));
